import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule, RouterModule, CardModule, ButtonModule, DividerModule],
    template: `
        <div class="login-wrapper">
            <p-card class="login-card">
                <ng-template pTemplate="header">
                    <div class="login-header">
                        <span class="title">Auth Sample Application</span>
                    </div>
                </ng-template>

                <div class="login-actions">
                    <button pButton type="button" label="Log in with SSO" icon="pi pi-sign-in" class="p-button-primary w-full" (click)="authorize()"></button>
                </div>
            </p-card>
        </div>
    `,
    styles: [
        `
            .login-wrapper {
                min-height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--surface-ground);
                padding: 2rem;
            }
            .login-card {
                width: 100%;
                max-width: 420px;
            }
            :host ::ng-deep .login-card .p-card {
                border-radius: var(--content-border-radius);
            }
            :host ::ng-deep .login-card .p-card-header {
                padding: 1rem 1.25rem 0.5rem 1.25rem;
            }
            :host ::ng-deep .login-card .p-card-body {
                padding: 0 1.25rem 1.25rem 1.25rem;
            }
            :host ::ng-deep .login-card .p-card-content {
                padding: 0;
            }
            :host ::ng-deep .login-card .p-divider-horizontal {
                margin: 0.5rem 0;
            }
            .login-header {
                display: flex;
                flex-direction: column;
                gap: 0.25rem;
                align-items: center;
                text-align: center;
            }
            .title {
                font-size: 1.25rem;
                font-weight: 600;
            }
            .subtitle {
                font-size: 0.875rem;
            }
            .login-actions {
                display: flex;
                flex-direction: column;
                gap: 0.75rem;
            }
            .w-full {
                width: 100%;
            }
            .text-center {
                text-align: center;
            }
            .link {
                color: var(--primary-color);
                text-decoration: none;
                font-size: 0.875rem;
                padding: 0.25rem 0;
            }
            .link:hover {
                text-decoration: underline;
            }
        `
    ]
})
export class LoginComponent {
    constructor(private authService: AuthService) {}

    authorize() {
        this.authService.authorize();
    }
}
